export default class Likes {
  constructor(el) {
    this.el = el;
    this.handSelector = this.el.getAttribute('data-hand-selector');
    this.hand = this.el.querySelector(this.handSelector);
    this.handValue = this.el.querySelector('.likes-like');
    this.userid = this.el.getAttribute('data-uid');
    this.galid = this.el.getAttribute('data-gallid');
    // green
    this.activeColor = '#4A9501';
    // gray
    this.pasiveColor = 'rgb(128, 128, 128)';

    this.init();
  }

  init() {
    this.hand.addEventListener('click', () => {
      if (this.hand.classList.contains('y-like')) {
        this.hand.style.color = this.pasiveColor;
        this.handValue.innerHTML = parseInt(this.handValue.innerHTML, 10) + 1;
        this.hand.classList.remove('y-like');
      } else {
        this.hand.style.color = this.activeColor;
        this.hand.classList.add('y-like');
        this.handValue.innerHTML = parseInt(this.handValue.innerHTML, 10) - 1;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/likes.js